import styled from 'styled-components';
import { colorCSS, fontSizes, radius } from '../../styles';
export const Skip = styled.div `
  .visually-hidden:not(:focus):not(:active) {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  #skip-to-content {
    display: inline-block;
    padding: 0.5rem 1.25rem;
    background: ${colorCSS('N800')};
    color: ${colorCSS('N0')};
    font-size: ${fontSizes.sm};
    border: 1px solid ${colorCSS('N800')};
    border-radius: ${radius.button};
    text-decoration: none;
    cursor: pointer;
    transition: all 250ms ease-out;
    &:hover {
      background: ${colorCSS('N400')};
      border: 1px solid ${colorCSS('N400')};
    }
    &:focus {
      outline: 1px solid ${colorCSS('N100')};
    }
    &:active {
      background: ${colorCSS('N100')};
      border: 1px solid ${colorCSS('N100')};
    }
    position: fixed;
    top: 0.5rem;
    left: 0.5rem;
    z-index: 1000;
  }
`;
//# sourceMappingURL=UiHeaderNav.styles.js.map